import { HeaderValues } from 'src/Utils/csv/csv.constants'

export interface ImportFrameworkSectionsCSVRow {
  sectionName: string
  sectionDetails: string
  requirementId: string
  requirementDetails: string
  controlIds: string[]
}

export const FRAMEWORK_SECTIONS_CSV_HEADERS: HeaderValues[] = [
  { input: 'section_name', output: 'sectionName' },
  {
    input: 'section_details',
    output: 'sectionDetails',
    optional: true,
  },
  { input: 'requirement_id', output: 'requirementId' },
  {
    input: 'requirement_details',
    output: 'requirementDetails',
    optional: true,
  },
  { input: 'control_ids', output: 'controlIds', optional: true },
]

export const FRAMEWORK_SECTIONS_CSV_TEMPLATE = [
  {
    section_name: 'Access control',
    section_details: 'Controls for logical and physical access.',
    requirement_id: 'Access reviews',
    requirement_details: 'Periodic access reviews are performed.',
    control_ids: '',
  },
  {
    section_name: 'Security',
    section_details: 'Controls for data encryption and transmission.',
    requirement_id: 'Encryption in transit',
    requirement_details: 'Data is encrypted using TLS.',
    control_ids: '',
  },
]
